import React, {useEffect, useState} from "react";
import {
    Tr,
    Td,
    Flex,
    Text,
    useColorModeValue,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Modal, useDisclosure, Icon,
} from "@chakra-ui/react";

import "../components/Tables/components/modal.css"
import {FaArrowAltCircleLeft, FaArrowAltCircleRight} from "react-icons/fa";
import {flexRender} from "@tanstack/react-table";

function TableAuditLogRow(props) {
    const { row } = props;
    const textColor = useColorModeValue("gray.700", "white");
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [result, setResult] = useState('')

    async function getVaultData(text) {
        let decodedString = decodeURIComponent(escape(atob(text)))
        setResult(decodedString)
        onOpen()
    }

    let cells = row.getVisibleCells();

    useEffect(() => {
        document.body.style.overflowY = "hidden";
        return () => {
            document.body.style.overflowY = "scroll";
        };
    }, []);

    return (
        <>
            <Tr>
                {/*ДАТА И ВРЕМЯ*/}
                <Td key={cells[0].id} pl="0px">
                    <Flex alignItems="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
                        <Text pl={'25px'} fontSize="xs" color={textColor} minWidth="100%">
                            {flexRender(
                                cells[0].column.columnDef.cell,
                                cells[0].getContext()
                            )}
                        </Text>
                    </Flex>
                </Td>
                {/*СОБЫТИЕ*/}
                <Td  key={cells[1].id}>
                    <Text fontSize="xs" color={textColor} minWidth="100%">
                        {flexRender(
                            cells[1].column.columnDef.cell,
                            cells[1].getContext()
                        )}
                    </Text>
                </Td>
                {/*ЗАПРОС*/}
                <Td key={cells[2].id}>
                    <Text fontSize="xs" color={textColor} minWidth="100%">
                        {flexRender(
                            cells[2].column.columnDef.cell,
                            cells[2].getContext()
                        )}
                    </Text>
                </Td>
                {/*ВРЕМЯ ОТВЕТА*/}
                <Td key={cells[3].id}>
                    <Text fontSize="xs" color={textColor} minWidth="100%" maxWidth="250px">
                        {flexRender(
                            cells[3].column.columnDef.cell,
                            cells[3].getContext()
                        )}
                    </Text>
                </Td>
                {/*ВРЕМЯ ОТВЕТА*/}
                <Td key={cells[4].id} minWidth={{ sm: "5px" }}>
                    <Button
                        p="0px"
                        bg="transparent"
                        onClick={() => {
                            getVaultData(cells[4].getContext().row.original['data/sanitized']['request/body']['content'])
                        }}
                    >
                        <Icon as={FaArrowAltCircleRight} color="gray.400" cursor="pointer" />
                    </Button>

                    <Button
                        p="0px"
                        bg="transparent"
                        onClick={() => {
                            getVaultData(cells[4].getContext().row.original['data/sanitized']['response/body']['content'])
                        }}
                    >
                        <Icon as={FaArrowAltCircleLeft} color="gray.400" cursor="pointer" />
                    </Button>
                </Td>
            </Tr>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>vault logs</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {result}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

export default TableAuditLogRow;
